/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveBasicCostDtoPage } from '../../models/effective-basic-cost-dto-page';

export interface ListEffectiveBasicCosts$Params {
  projectId?: string | null;
  costTypeIds?: Array<string>;
  budgetIds?: Array<string>;
  wpIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'outflowDate' | '-outflowDate' | 'unit' | '-unit' | 'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'total' | '-total' | 'project' | '-project' | 'budget' | '-budget' | 'budgetName' | '-budgetName' | 'costType' | '-costType' | 'costTypeName' | '-costTypeName' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listEffectiveBasicCosts(http: HttpClient, rootUrl: string, params?: ListEffectiveBasicCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveBasicCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEffectiveBasicCosts.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('costTypeIds', params.costTypeIds, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveBasicCostDtoPage>;
    })
  );
}

listEffectiveBasicCosts.PATH = '/v0/effectiveBasicCost';
